export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-mask/index.js